"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPartnerPriceSearchModel = instanceOfPartnerPriceSearchModel;
exports.PartnerPriceSearchModelFromJSON = PartnerPriceSearchModelFromJSON;
exports.PartnerPriceSearchModelFromJSONTyped = PartnerPriceSearchModelFromJSONTyped;
exports.PartnerPriceSearchModelToJSON = PartnerPriceSearchModelToJSON;
exports.PartnerPriceSearchModelToJSONTyped = PartnerPriceSearchModelToJSONTyped;
/**
 * Check if a given object implements the PartnerPriceSearchModel interface.
 */
function instanceOfPartnerPriceSearchModel(value) {
    return true;
}
function PartnerPriceSearchModelFromJSON(json) {
    return PartnerPriceSearchModelFromJSONTyped(json, false);
}
function PartnerPriceSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
    };
}
function PartnerPriceSearchModelToJSON(json) {
    return PartnerPriceSearchModelToJSONTyped(json, false);
}
function PartnerPriceSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'orgId': value['orgId'],
        'frameNo': value['frameNo'],
    };
}
